
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story",
      function () {
        return require("private-next-pages/story.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/story"])
      });
    }
  